import React, { useState } from "react";
import SwitchControl from "../../components/site/SwitchControl";
import { Eyebrow } from "../../components/site/kit";
import { WorkingState } from "../../components/site/motion";
import { Reveal } from "../../components/site/motion";
import { useHomeCopy } from "../../lib/siteContent";
import { RichCopy } from "../../components/site/RichCopy";
import { BgDepth } from "./shared";

const MorphCard = () => {
  const [on, setOn] = useState(false);
  const toggle = () => setOn((v) => !v);
  return (
    <>
      <div
        onClick={toggle}
        onKeyDown={(e) => { if (e.key === "Enter" || e.key === " ") { e.preventDefault(); toggle(); } }}
        role="button"
        tabIndex={0}
        aria-pressed={on}
        aria-label="Toggle from working apart to working as one"
        data-testid="whatwedo-morph"
        className="relative flex min-h-[340px] cursor-pointer items-center justify-center overflow-hidden border-2 p-8 outline-none transition-[background-color,border-color] duration-500 focus-visible:ring-2 focus-visible:ring-[#5f8f10] focus-visible:ring-offset-2"
        style={{ backgroundColor: on ? "#161A15" : "#1f241d", borderColor: on ? "rgba(95,143,16,0.6)" : "rgba(255,255,255,0.14)" }}
      >
        <WorkingState active={on} />
        <span className="absolute left-6 top-6 font-body text-[0.65rem] font-semibold uppercase tracking-[0.2em] text-white/45">
          {on ? "Separate efforts, one agenda" : "Separate efforts"}
        </span>
        <span className={`absolute bottom-6 left-6 font-body text-sm font-semibold uppercase tracking-[0.14em] transition-colors duration-300 ${on ? "text-[#5f8f10]" : "text-white/55"}`}>
          {on ? "Working as one" : "Working apart"}
        </span>
      </div>
      <div className="mt-5 flex items-center justify-between gap-6">
        <p className="font-body max-w-md text-lg font-normal leading-relaxed text-black/70">
          Flip the switch and see the shift, from separate efforts to one growth agenda.
        </p>
        <SwitchControl active={on} onToggle={toggle} size="md" tone="light" ariaLabel="Toggle from working apart to working as one" testId="whatwedo-switch" />
      </div>
    </>
  );
};

export const WhatWeDo = () => {
  const c = useHomeCopy();
  return (
  <section data-testid="home-what-we-do" className="relative overflow-hidden border-b border-black/10 bg-[#F7F6F2]">
    <BgDepth />
    <div className="relative mx-auto max-w-[1360px] px-6 py-24 md:px-12 md:py-32 lg:px-16">
      <div className="grid items-center gap-12 lg:grid-cols-12 lg:gap-16">
        <Reveal className="lg:col-span-6">
          <Eyebrow>{c.problemEyebrow}</Eyebrow>
          <h2 className="font-display mt-6 text-4xl leading-[0.95] tracking-tight text-black md:text-5xl lg:text-6xl">
            <RichCopy text={c.problemHeading} />
          </h2>
          <p className="font-body mt-8 max-w-xl text-xl font-normal leading-relaxed text-black">
            {c.problemIntro}
          </p>
        </Reveal>
        <div className="lg:col-span-6">
          <MorphCard />
        </div>
      </div>
    </div>
  </section>
  );
};

